// Titles are constants for the more info modals that are shown to the user
export enum INDIVIDUAL_PROJECT_GRAPH_TITLES {
    GENERATION = "Generation",
    SETTLEMENT_FORECAST = "Settlement Forecast",
    FLOATING_PRICE = "Floating Price",
    IMPLIED_CARBON_PRICE = "Implied Carbon Price",
    LME_TOTAL_CARBON = "LME Total Carbon Reduction",
    CARBON_FREE = "Carbon Free Energy",
    NODAL_BASIS = "Nodal Basis",
}

export enum SELLER_DASHBOARD_TITLES {
    ACTIVE_CONTRACTS = "Active Contracts",
    INACTIVE_CONTRACTS = "Inactive Contracts",
}

export enum BUYER_DASHBOARD_TITLES {
    ACTIVE_RFQS = "Active RFQs",
    INACTIVE_RFQS = "Inactive RFQs",
}

export enum SHARED_DASHBOARD_TITLES {
    TRADING_ACTIVITY = "Trading Activity",
    NEGOTIATIONS = "Negotiations",
    EXECUTED = "Executed",
    TERMINATED = "Terminated",
}

// More info items are constants that used for determining title and content. They are not shown to the user
export enum MORE_INFO_ITEMS {
    GENERATION = "generation-item",
    SETTLEMENT_FORECAST = "settlement-forecast-item",
    FLOATING_PRICE = "floating-price-item",
    IMPLIED_CARBON_PRICE = "implied-carbon-price-item",
    LME_TOTAL_CARBON = "LME Total Carbon Reduction",
    CARBON_FREE = "Carbon Free Energy",
    NODAL_BASIS = "nodal-basis-item",
    ACTIVE_CONTRACTS = "active-contracts-item",
    INACTIVE_CONTRACTS = "inactive-contracts-item",
    ACTIVE_RFQS = "active-rfqs-item",
    INACTIVE_RFQS = "inactive-rfqs-item",
    SELLER_TRADING_ACTIVITY = "seller-trading-activity-item",
    BUYER_TRADING_ACTIVITY = "buyer-trading-activity-item",
    NEGOTIATIONS = "negotiations-item",
    EXECUTED = "executed-item",
    TERMINATED = "terminated-item",
}

// Map of more info items to their titles
export const MORE_INFO_ITEM_TO_TITLE_VIEW = new Map<MORE_INFO_ITEMS, INDIVIDUAL_PROJECT_GRAPH_TITLES | SELLER_DASHBOARD_TITLES | BUYER_DASHBOARD_TITLES | SHARED_DASHBOARD_TITLES>([
    [MORE_INFO_ITEMS.GENERATION, INDIVIDUAL_PROJECT_GRAPH_TITLES.GENERATION],
    [MORE_INFO_ITEMS.SETTLEMENT_FORECAST, INDIVIDUAL_PROJECT_GRAPH_TITLES.SETTLEMENT_FORECAST],
    [MORE_INFO_ITEMS.FLOATING_PRICE, INDIVIDUAL_PROJECT_GRAPH_TITLES.FLOATING_PRICE],
    [MORE_INFO_ITEMS.IMPLIED_CARBON_PRICE, INDIVIDUAL_PROJECT_GRAPH_TITLES.IMPLIED_CARBON_PRICE],
    [MORE_INFO_ITEMS.LME_TOTAL_CARBON, INDIVIDUAL_PROJECT_GRAPH_TITLES.LME_TOTAL_CARBON],
    [MORE_INFO_ITEMS.CARBON_FREE, INDIVIDUAL_PROJECT_GRAPH_TITLES.CARBON_FREE],
    [MORE_INFO_ITEMS.NODAL_BASIS, INDIVIDUAL_PROJECT_GRAPH_TITLES.NODAL_BASIS],
    [MORE_INFO_ITEMS.ACTIVE_CONTRACTS, SELLER_DASHBOARD_TITLES.ACTIVE_CONTRACTS],
    [MORE_INFO_ITEMS.INACTIVE_CONTRACTS, SELLER_DASHBOARD_TITLES.INACTIVE_CONTRACTS],
    [MORE_INFO_ITEMS.ACTIVE_RFQS, BUYER_DASHBOARD_TITLES.ACTIVE_RFQS],
    [MORE_INFO_ITEMS.INACTIVE_RFQS, BUYER_DASHBOARD_TITLES.INACTIVE_RFQS],
    [MORE_INFO_ITEMS.SELLER_TRADING_ACTIVITY, SHARED_DASHBOARD_TITLES.TRADING_ACTIVITY],
    [MORE_INFO_ITEMS.BUYER_TRADING_ACTIVITY, SHARED_DASHBOARD_TITLES.TRADING_ACTIVITY],
    [MORE_INFO_ITEMS.NEGOTIATIONS, SHARED_DASHBOARD_TITLES.NEGOTIATIONS],
    [MORE_INFO_ITEMS.EXECUTED, SHARED_DASHBOARD_TITLES.EXECUTED],
    [MORE_INFO_ITEMS.TERMINATED, SHARED_DASHBOARD_TITLES.TERMINATED],
]);